module.exports = __webpack_public_path__ + "32cda6f95d45747cca5d992c8778ffbe.jpg";